import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

export default function Notification(props) {
  const { notify, setNotify } = props;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setNotify({
      ...notify,
      isOpen: false,
    });
  };

  return (
    <Snackbar
      open={notify.isOpen}
      autoHideDuration={15000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
    >
      <Alert
        severity={notify.type ? notify.type : "error"}
        onClose={handleClose}
      >
        {notify.message}
      </Alert>
    </Snackbar>
  );
}
